import { render, staticRenderFns } from "./wendang.vue?vue&type=template&id=09dcb395&scoped=true&"
import script from "./wendang.vue?vue&type=script&lang=js&"
export * from "./wendang.vue?vue&type=script&lang=js&"
import style0 from "./wendang.vue?vue&type=style&index=0&id=09dcb395&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dcb395",
  null
  
)

export default component.exports